<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ppProgramAPI from "../../../services/standards/promotionPrevention/ppProgramAPI";
import ppMatrixAPI from "../../../services/standards/promotionPrevention/ppMatrixAPI";
import { dateFormat } from "@/utils/helpers/format";

const BUCKET = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/7.1.1";

/**
 * 7.1.1 Promoción y Prevención — hub del ítem:
 * (1) formatos en blanco descargables (Programa + Matriz/Cronograma),
 * (2) Programa P&P online versionable → PDF firmado (SST-FT-031),
 * (3) Matriz y Cronograma P&P online versionable + dashboard → PDF firmado (SST-FT-032),
 * (4) enlace al registro de Acciones Correctivas/Preventivas (corrective_actions) que ya existía.
 */
export default {
  page: {
    title: "7.1.1 Promoción y Prevención",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal },
  data() {
    return {
      title: "7.1.1 Promoción y Prevención",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "Promoción y Prevención", active: true },
      ],
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      programs: [],
      matrices: [],
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(57) // 57 = 7.1.1
        .then((response) => { this.itemData = response; this.loading = false; })
        .catch((error) => { console.log(error); this.loading = false; });
    },
    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) { console.log(e); return false; }
    },
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 57)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response && response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => console.log(error));
    },
    async changeItemStatus(itemStatus) {
      try {
        await newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 57, status: itemStatus });
        Swal.fire({ title: "¡Éxito!", text: "¡Se ha cambiado el estado del ítem con éxito!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
        setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        Swal.fire({ title: "¡Error!", text: "¡No se ha actualizado el estado del ítem!", icon: "error", confirmButtonClass: "btn btn-confirm mt-2" });
        setTimeout(() => window.location.reload(), 2000);
        console.error(error);
      }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const permissions = this.$store.state.auth.info.permissions;
      const enabled = permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    dateConvert(date) { return date ? dateFormat(date) : ""; },
    statusBadgeClass(s) { return s === "signed" ? "badge-success" : "badge-secondary"; },
    statusText(s) { return s === "signed" ? "Firmado" : "Borrador"; },

    descargarFormato(tipo) {
      const file = tipo === "matriz" ? "MATRIZ_PROMOCION_Y_PREVENCION_7.1.1.xlsx" : "PROGRAMA_PROMOCION_Y_PREVENCION_7.1.1.docx";
      window.open(`${BUCKET}/${file}`);
    },
    goRegistroAcpm() { this.$router.push({ path: `/forms/estandares/${this.companyID}/acciones-correctivas-preventivas` }); },

    // ── Programa P&P ──
    getPrograms() {
      ppProgramAPI.getAll(this.companyID, 1)
        .then((r) => { this.programs = (r && r.List && r.List.data) ? r.List.data : []; })
        .catch((e) => console.log(e));
    },
    newProgram() { this.$router.push({ path: `/forms/estandares/${this.companyID}/pp-programa` }); },
    editProgram(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/pp-programa/${id}` }); },
    downloadProgramPdf(id) { window.open(ppProgramAPI.pdfUrl(id), "_blank"); },
    cloneProgram(id) {
      Swal.fire({ title: "¿Crear nueva versión?", text: "Se clonará esta versión del programa en una nueva editable.", icon: "question", showCancelButton: true, confirmButtonText: "Crear versión", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        ppProgramAPI.cloneVersion(id).then((r) => { if (r && r.id) this.editProgram(r.id); }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo clonar", "error"); });
      });
    },
    deleteProgram(id) {
      Swal.fire({ title: "¿Eliminar versión?", icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        ppProgramAPI.delete(id).then(() => { Swal.fire({ title: "Eliminada", icon: "success", timer: 1200, showConfirmButton: false }); this.getPrograms(); }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },

    // ── Matriz y cronograma P&P ──
    getMatrices() {
      ppMatrixAPI.getAll(this.companyID, 1)
        .then((r) => { this.matrices = (r && r.List && r.List.data) ? r.List.data : []; })
        .catch((e) => console.log(e));
    },
    newMatrix() { this.$router.push({ path: `/forms/estandares/${this.companyID}/pp-matriz` }); },
    editMatrix(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/pp-matriz/${id}` }); },
    downloadMatrixPdf(id) { window.open(ppMatrixAPI.pdfUrl(id), "_blank"); },
    cloneMatrix(id) {
      Swal.fire({ title: "¿Crear nueva versión?", text: "Se clonarán las actividades de esta versión en una nueva editable.", icon: "question", showCancelButton: true, confirmButtonText: "Crear versión", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        ppMatrixAPI.cloneVersion(id).then((r) => { if (r && r.id) this.editMatrix(r.id); }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo clonar", "error"); });
      });
    },
    deleteMatrix(id) {
      Swal.fire({ title: "¿Eliminar versión?", text: "Se eliminará la matriz y sus actividades.", icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        ppMatrixAPI.delete(id).then(() => { Swal.fire({ title: "Eliminada", icon: "success", timer: 1200, showConfirmButton: false }); this.getMatrices(); }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getPrograms();
    this.getMatrices();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <!-- Descripción + estado + descargas + registro ACPM -->
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Define e implementa las actividades de promoción de la salud y prevención de riesgos del SG-SST:
                      hábitos y estilos de vida saludables, control de factores de riesgo, campañas, capacitaciones y
                      vigilancia epidemiológica, con seguimiento mediante indicadores.
                    </p>
                    <p class="text-justify">
                      Diligencia el <b>Programa de P&amp;P</b> y la <b>Matriz y Cronograma</b> en línea (versionables y
                      firmables), descarga los formatos en blanco, o gestiona el registro de acciones correctivas y
                      preventivas.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="col-12 text-right m-b-0 d-flex justify-content-end flex-wrap align-items-center">
                <button type="button" class="btn btn-light mx-1" @click="goRegistroAcpm">
                  <i class="mdi mdi-clipboard-list-outline"></i> Registro de acciones correctivas/preventivas
                </button>
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormato('programa')">
                  <i class="bx bx-download"></i> Programa (Word)
                </button>
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormato('matriz')">
                  <i class="bx bx-download"></i> Matriz/Cronograma (Excel)
                </button>
              </div>
            </div>
          </div>

          <!-- Programa P&P (online, versionable, firmable) -->
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-0">Programa de P&amp;P (online)</h5>
                  <p class="text-muted small mb-1">Documento estructurado versionable con firma del encargado. Cada versión queda en el historial.</p>
                </div>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newProgram" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus"></i> Nuevo programa
                </button>
              </div>
              <div class="table-responsive mt-1">
                <table class="table table-sm border-bottom table-striped">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Versión</th>
                      <th class="text-center align-middle">Fecha aprobación</th>
                      <th class="text-center align-middle">Estado</th>
                      <th class="text-center align-middle">PDF</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!programs.length"><td colspan="5" class="text-center text-muted">No hay programas registrados.</td></tr>
                    <tr v-for="p in programs" :key="p.id">
                      <td class="text-center align-middle font-weight-bold">{{ p.version }}</td>
                      <td class="text-center align-middle">{{ p.approval_date ? dateConvert(p.approval_date) : '' }}</td>
                      <td class="text-center align-middle"><span class="badge" :class="statusBadgeClass(p.workflow_status)">{{ statusText(p.workflow_status) }}</span></td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;" type="button" @click="downloadProgramPdf(p.id)" title="Descargar PDF">
                          <i class="mdi mdi-file-pdf-box" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar')" @click="editProgram(p.id)">{{ p.workflow_status === 'signed' ? 'Ver' : 'Editar' }}</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Crear')" @click="cloneProgram(p.id)">Nueva versión (clonar)</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteProgram(p.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Matriz y cronograma P&P (online, versionable + dashboard, firmable) -->
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-0">Matriz y Cronograma de P&amp;P (online)</h5>
                  <p class="text-muted small mb-1">Cronograma anual planeado/ejecutado, versionable con dashboard y firma del encargado.</p>
                </div>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newMatrix" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus"></i> Nueva matriz
                </button>
              </div>
              <div class="table-responsive mt-1">
                <table class="table table-sm border-bottom table-striped">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Versión</th>
                      <th class="text-center align-middle">Año</th>
                      <th class="text-center align-middle">Actividades</th>
                      <th class="text-center align-middle">Estado</th>
                      <th class="text-center align-middle">PDF</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!matrices.length"><td colspan="6" class="text-center text-muted">No hay matrices registradas.</td></tr>
                    <tr v-for="m in matrices" :key="m.id">
                      <td class="text-center align-middle font-weight-bold">{{ m.version }}</td>
                      <td class="text-center align-middle">{{ m.anio }}</td>
                      <td class="text-center align-middle">{{ m.rows_count }}</td>
                      <td class="text-center align-middle"><span class="badge" :class="statusBadgeClass(m.workflow_status)">{{ statusText(m.workflow_status) }}</span></td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;" type="button" @click="downloadMatrixPdf(m.id)" title="Descargar PDF">
                          <i class="mdi mdi-file-pdf-box" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar')" @click="editMatrix(m.id)">{{ m.workflow_status === 'signed' ? 'Ver' : 'Editar' }}</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Crear')" @click="cloneMatrix(m.id)">Nueva versión (clonar)</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteMatrix(m.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="text-center pt-4"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
        </div>
      </div>
    </div>
  </Layout>
</template>
